import createIcon from '../../createIcon';

/**
 * @component @name VerticalShadesClosed
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMTlWM0g0VjE5SDJWMjFIMjJWMTlIMjBaTTEzIDVIMTQuNVYxOUgxM1Y1Wk0xMSAxOUg5LjVWNUgxMVYxOVpNNiA1SDcuNVYxOUg2VjVaTTE2LjUgMTlWNUgxOFYxOUgxNi41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const VerticalShadesClosed = createIcon('VerticalShadesClosed', [
  [
    'path',
    {
      d: 'M20 19V3H4V19H2V21H22V19H20ZM13 5H14.5V19H13V5ZM11 19H9.5V5H11V19ZM6 5H7.5V19H6V5ZM16.5 19V5H18V19H16.5Z',
      key: '1nbu05',
    },
  ],
]);

export default VerticalShadesClosed;
